import React, { Component } from 'react';
import { Redirect, matchPath } from 'react-router';
import { Route } from 'react-router-dom';

import firebase from 'firebase';

export default class RequireLogin extends Component {
  render() {
    if (this.props.computedMatch && !firebase.auth().currentUser) {
      return <Redirect push to={`/login?next=${window.location.pathname}`} />;
    } else {
      return <Route {...this.props} />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/RequireLogin.js